import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/logo.png';

const lexend = '"Lexend", sans-serif';

export default function SiteFooter() {
  return (
    <footer className="site-footer" style={{
      background: '#1c3dfe',
      color: 'white',
      padding: '1.25rem 2rem',
      textAlign: 'center',
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.75rem',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'white' }}>
          <img
            src={logoImg}
            alt="NearStay"
            style={{ height: '48px', width: 'auto' }}
          />
          <span style={{
            fontFamily: lexend,
            fontOpticalSizing: 'auto',
            fontSize: '1.65rem',
            fontWeight: 700,
            color: 'white',
          }}>
            NearStay
          </span>
        </Link>
        <span style={{
          fontFamily: lexend,
          fontOpticalSizing: 'auto',
          fontSize: '0.85rem',
          opacity: 0.9,
        }}>
          © {new Date().getFullYear()} NearStay
        </span>
      </div>
    </footer>
  );
}
